//wait dom to be ready
document.addEventListener("DOMContentLoaded", function() {
    // Add click event listeners to tabs
    document.getElementById('arrivals').addEventListener('click', function() {
        setActiveTab('arrivals');
        doSearch();
    });
    
    document.getElementById('departures').addEventListener('click', function() {
        setActiveTab('departures');
        doSearch();
    });

    //trigger dosearch only if elementid flight_number has 3 or more characters or is empty
    document.getElementById('flight_number').addEventListener('keyup', function (e) {
        if (e.target.value.length >= 3 || e.target.value.length == 0) {
            doSearch();

        }
    });

    doSearch();
});

function loadSearch(){
    //get value from element id flightSearch and redirect to flight_info passing the value as parameter
    var flightSearch = document.getElementById('flightSearch').value;
    window.location.href = '/sxm-flight-status?flight=' + encodeURIComponent(flightSearch);
}

function setActiveTab(tabId) {
    // Remove active class from all tabs
    document.querySelectorAll('#tabs li').forEach(function(tab) {
        tab.classList.remove('active');
    });
    
    // Add active class to selected tab
    document.getElementById(tabId).classList.add('active');
}

function doSearch() {
    var view = document.querySelector('#tabs li.active').id;
    var airline = document.getElementById('airline').value;
    var flight_number = document.getElementById('flight_number').value;
    var date_filter = document.getElementById('date_filter').value;

    // Show loading indicator
    document.getElementById('results').innerHTML = '<div class="loading">Loading...</div>';

    // Create AJAX request
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/ajax/functions.php?operation=getFlightStatus&view=' + view + '&airline=' + airline + '&flight_number=' + flight_number + '&date_filter=' + date_filter, true);
    xhr.onload = function() {
        if (xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            displayResults(response.data);
        } else {
            document.getElementById('results').innerHTML = '<div class="error">Error loading data.</div>';
        }
    };
    xhr.send();
}


function displayResults(data) {
    var resultsHtml = '';

    let airlines = data.airlines || [];
    let flights = data.flights || [];

    if (flights.length > 0) {
        resultsHtml = '<div class="flight-results">';

        flights.forEach(function(flight) {
            var statusClass = getStatusClass(flight.remarkscode);
            var displayTime = flight.actdate && flight.actdate !== 'NULL' ? 
                formatTime(flight.actdate) : 
                (flight.estdate && flight.estdate !== 'NULL' ? formatTime(flight.estdate) : formatTime(flight.scheddate));
            
            resultsHtml += 
                '<div class="flight-item ' + statusClass + '">' +
                    '<div class="flight-main-info">' +
                        '<div class="flight-number">' +
                            '<span class="airline-code">' + flight.airlinecode + '</span>' +
                            '<span class="flight-num">' + flight.flightnumber.replace(flight.airlinecode + ' ', '') + '</span>' +
                            
                        '</div>' +
                        '<div class="flight-route">' +
                            '<span class="label">Airline:</span>' +
                            '<span class="airline-name">' + airlines[flight.airlinecode] + '</span>' +
                        '</div>' +
                        '<div class="flight-route">' +
                            '<span class="label">Destination:</span>' +
                            '<span class="city">' + flight.cityname + '</span>' +
                        '</div>' +
                        '<div class="flight-times">' +
                            '<div class="scheduled">' +
                                '<span class="label">Scheduled:</span>' +
                                '<span class="time">' + formatTime(flight.scheddate) + '</span>' +
                            '</div>' +
                            '<div class="actual">' +
                                '<span class="label">' + (flight.actdate && flight.actdate !== 'NULL' ? 'Actual:' : 'Estimated:') + '</span>' +
                                '<span class="time">' + displayTime + '</span>' +
                            '</div>' +
                        '</div>' +
                        '<div class="flight-status">' +
                            '<span class="status ' + statusClass + '">' + flight.remark + '</span>' +
                        '</div>' +
                    '</div>' +
                '</div>';
        });
        
        resultsHtml += '</div>';
    } else {
        resultsHtml = '<div class="no-results">No flights found for the selected criteria.</div>';
    }
    
    document.getElementById('results').innerHTML = resultsHtml;
}

function getStatusClass(remarkscode) {
    switch(remarkscode) {
        case 'LAN': return 'landed';
        case 'ONT': return 'on-time';
        case 'DEL': return 'delayed';
        case 'CAN': return 'cancelled';
        default: return 'scheduled';
    }
}

function formatTime(dateString) {
    if (!dateString || dateString === 'NULL') return '--:--';
    var date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false 
    });
}


function clearFilters() {
    document.getElementById('airline').value = '';
    document.getElementById('flight_number').value = '';
    document.getElementById('date_filter').value = new Date().toISOString().split('T')[0];
    doSearch();
}